import $http from '../../axios-instance';
import Swal from 'sweetalert2'
import {dispatch} from 'rxjs/internal/observable/pairs';

/**
 *
 *
 * @export
 * @param {*} { commit, state, dispatch }
 */
export async function getRoles({commit, state, dispatch}) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`/roles`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setAdmRoles', response.data.data)
            state.error = false
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            commit('rolesError', error.message)
        })
}

/**
 *
 *
 * @export
 * @param {*} { commit, state, dispatch }
 * @param {*} rol
 */
export async function getPermisosPorRol({commit, state, dispatch}, rol) {

    if (rol === undefined) {
        rol = state.rolusuario
    }

    commit('dashboard/load', true, {root: true});
    commit('cambiaAdmRolUsuario', rol);
    await $http.get(`/roles/${rol}`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setAdmPermisosRol', response.data)
            // dispatch('getPermisosFiltro', { permiso: null, key: null });
            state.error = false
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            //commit('mensajeError', error.message)
        })
}

/**
 * Método para obtener todos los permisos registrados en el sistema.
 *
 * @export
 * @param {*} { commit, state }
 * @param {*} [requestParameters={params: state.busca}]
 */
export async function getPermisosFiltro({commit, state}, requestParameters = {params: state.busca}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('permisos', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setPermisos', response.data.data)
            state.error = false
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            commit('permisosAdmError', error.message)
        })
}

/**
 *
 *
 * @export
 * @param {*} { commit, state, dispatch }
 * @param {*} permiso
 */
export async function actualizarPermiso({commit, state, dispatch}, permiso) {
    commit('dashboard/load', true, {root: true});
    await $http.post('permisos/editar', permiso)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            })
            await dispatch('getPermisosFiltro');
            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        })
}

/**
 *
 *
 * @export
 * @param {*} { commit, state }
 */
export async function guardaPermisosRol({commit, state}) {
    commit('dashboard/load', true, {root: true});
    await $http.put(`roles/editar/${state.rolusuario}`, {
        permisosarr: state.permisosSeleccionados,
        rol: state.rolusuario
    })
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            })
            //commit('setAdmPermisosRoles', response.data)
            state.error = false
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            commit('permisosAdmError', error.message)
        })
}

/**
 *
 *
 * @export
 * @param {*} { commit, state, dispatch }
 * @param {*} descripcion
 */
export async function crearRol({commit, state, dispatch}, descripcion) {
    commit('dashboard/load', true, {root: true});
    await $http.post(`roles/crear`, {descripcion: descripcion, activo: 1})
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            })
            dispatch('getRoles');
            state.error = false
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        })
}

/**
 *
 *
 * @export
 * @param {*} { commit, state, dispatch }
 * @param {*} datos
 */
export async function crearPermiso({commit, state}, datos) {
    commit('dashboard/load', true, {root: true});
    await $http.post(`permisos/crear`, {descripcion: datos.descripcion, key: datos.key, activo: 1})
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            })
            state.error = false
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        })
}


/**
 * Método para consultar los controles paramétricos
 *
 * @export
 * @param {*} { state, commit }
 * @param {*} [requestParameters={ params: state.filtroControles }]
 */
export async function getControles({state, commit}, requestParameters = {params: state.filtroControles}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('adm_general/control', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setControles', response.data.data)
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
        })
}

/**
 *
 *
 * @export
 * @param {*} { state, commit }
 * @param {*} [requestParameters={ params: state.filtroListas }]
 */
export async function getListas({state, commit}, requestParameters = {params: state.filtroListas}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('adm_general/listas', requestParameters)
        .then((response) => {

            commit('dashboard/load', false, {root: true});
            commit('setListas', response.data.data)
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
        })
    commit('dashboard/load', false, {root: true});
}

/**
 *
 *
 * @export
 * @param {*} { commit, state }
 */
export async function crearControl({commit, state}) {
    commit('dashboard/load', true, {root: true});
    await $http.post('adm_general/control/crear', state.selectedControles)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 5000
            })
            state.error = false
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
            commit('licenciaError', error.message)
        })
}

/**
 *
 *
 * @export
 * @param {*} { commit }
 * @param {*} id
 */
export async function mostrarControl({commit}, id) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`adm_general/control/mostrar/${id}`).then((response) => {
        commit('dashboard/load', false, {root: true});
        commit('setControl', response.data.data)
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.errors,
            showConfirmButton: true,
            timer: 5000
        })
        commit('accionError', error.message)
    })
}

/**
 *
 *
 * @export
 * @param {*} { commit, state, dispatch }
 */
export async function actualizarControl({commit, state}) {
    commit('dashboard/load', true, {root: true});
    await $http.put(`adm_general/control/editar/${state.selectedControles.id}`, state.selectedControles)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 1500
            })
            state.error = false
        }).catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
            commit('accionError', error.message)
        })
}

/**
 *
 *
 * @export
 * @param {*} { commit, state }
 */
export async function crearLista({commit, state}) {
    commit('dashboard/load', true, {root: true});
    await $http.post('adm_general/listas/crear', state.selectedListas)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 5000
            })
            state.error = false
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
            commit('licenciaError', error.message)
        })
}

/**
 *
 *
 * @export
 * @param {*} { commit }
 * @param {*} id
 */
export async function mostrarLista({commit}, id) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`adm_general/listas/mostrar/${id}`).then((response) => {
        commit('dashboard/load', false, {root: true});
        commit('setLista', response.data.data)
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.errors,
            showConfirmButton: true,
            timer: 5000
        })
        commit('accionError', error.message)
    })
}

/**
 *
 *
 * @export
 * @param {*} { commit, state }
 */
export async function actualizarLista({commit, state}) {
    commit('dashboard/load', true, {root: true});
    await $http.put(`adm_general/listas/editar/${state.selectedListas.id}`, state.selectedListas)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 5000
            })
            state.error = false
        }).catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
            commit('accionError', error.message)
        })
}

/**
 * Método para cambiar la cantidad de registros de controles por página
 *
 * @export
 * @param {*} { commit, dispatch }
 * @param {*} perPage
 */
export async function setPerPagePaginationControles({commit, dispatch}, perPage) {
    commit('setPageControles', 1);
    commit('setPerPageControles', parseInt(perPage));
    await dispatch('getControles')
}

/**
 * Método para cambiar la cantidad de registros de listas por página
 *
 * @export
 * @param {*} { commit, dispatch }
 * @param {*} perPage
 */
export async function setPerPagePaginationListas({commit, dispatch}, perPage) {
    commit('setPageListas', 1);
    commit('setPerPageListas', parseInt(perPage));
    await dispatch('getListas')
}

// Pagination
export async function setPagePaginationControles({commit, dispatch}, page) {
    commit('setPageControles', parseInt(page))
    await dispatch('getControles')
}

export async function setPagePaginationListas({commit, dispatch}, page) {
    commit('setPageListas', parseInt(page))
    await dispatch('getListas')
}


